export default "__VITE_ASSET__DJTtUdA9__"